import { Meta } from '@/src/components/common/Meta';
import JamEventView from '@/src/components/game/JamEventView/JamEventView';
import { useJamEventDetails } from '@/src/store/jam-event-details.context';
import React from 'react';

export const JamEventPage: React.FC = () => {
  const { event } = useJamEventDetails();

  return (
    <>
      <Meta title={event?.title} />
      <JamEventView />
    </>
  );
};
